<template>
  <div class="flex items-center text-sm">
    <div class="text-sm font-bold py-xs md:py-sm">
      {{ t('event.courseType') }}
    </div>
  </div>
  <div class="flex justify-between w-full space-x-sm md:space-x-md">
    <template
      v-for="(eType, i) in [
        ECourseType.INHOUSE,
        ECourseType.HYBRID,
        ECourseType.ONLINE,
      ]"
      :key="i"
    >
      <EventCourseIndicator
        :course-type="eType"
        :is-available="availableTypes.includes(eType)"
        :is-active="selected[eType]"
        :show-label="true"
        @toggle="(v) => (selected[eType] = v)"
      />
    </template>
  </div>
</template>
<script setup lang="ts">
import { ECourseType } from '@/@types/course-type';

import EventCourseIndicator from '@/components/event/event-course-indicator.vue';
import type { FilterOptions } from '@/components/components/advancedList/useAdvancedList';
import { FilterType } from './filter/utils';

const props = defineProps({
  filters: {
    type: Object as PropType<Record<string, any>>,
    required: true,
    default: () => ({}) as Record<string, any>,
  },
  filterOptions: {
    type: Object as PropType<FilterOptions>,
    required: true,
    default: () => ({}) as FilterOptions,
  },
});

const emits = defineEmits<{
  (e: 'changeFilter', key: string, value: any): void;
}>();

const { t } = useTrans();

const availableTypes = computed(() => {
  const options = props.filterOptions[FilterType.COURSE_TYPE];
  if (options && options.values) {
    return options.values.map(({ id }) => id);
  }
  return [];
});

const selected = reactive<Partial<Record<ECourseType, boolean>>>({
  [ECourseType.INHOUSE]: false,
  [ECourseType.HYBRID]: false,
  [ECourseType.ONLINE]: false,
});

watch(selected, (v) => {
  const values = Object.entries(v)
    .filter((cur) => !!cur[1])
    .map((cur) => cur[0] as ECourseType);
  emits('changeFilter', FilterType.COURSE_TYPE, values);
});

watch(
  () => props.filters[FilterType.COURSE_TYPE],
  (newValue) => {
    if (newValue) {
      Object.keys(selected).forEach((cur) => {
        selected[cur as ECourseType] = newValue.includes(cur);
      });
    } else {
      Object.keys(selected).forEach((cur) => {
        selected[cur as ECourseType] = false;
      });
    }
  },
);
</script>
